import React, { PureComponent } from 'react'

class Spinner extends PureComponent {
  render () {
    let sizeClass = `fa-${this.props.size}x`
    return <i className={'fa fa-spinner fa-spin ' + sizeClass + ' fa-fw'} />
  }
}

Spinner.defaultProps = {
  size: 3
}

export default Spinner



// WEBPACK FOOTER //
// ./src/app/shared/elements/spinner/index.js